<template>
    <form-row title="Home Office Coordinator">
        <div class="flex-1">
            <div class="flex-1 flex flex-col sm:flex-row">
                <div class="sm:col-gap-1 flex-1 mb-2 sm:-mt-4">
                    <input-text
                        label="Name"
                        name="contacts[home_office_coordinator][name]"
                        :value="contact.name"
                        placeholder="Name"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mb-2 sm:-mt-4">
                    <input-text
                        label="E-Mail"
                        name="contacts[home_office_coordinator][email]"
                        :value="contact.email"
                        placeholder="E-Mail"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mb-2 sm:-mt-4">
                    <input-text
                        label="Phone"
                        name="contacts[home_office_coordinator][phone]"
                        :value="contact.phone"
                        placeholder="Phone"
                        :read_only="read_only"
                    />
                </div>
            </div>

            <send-notifications
                v-if="! read_only"
                :name="'contacts[home_office_coordinator][receives_notifications]'"
                :value="contact.receives_notifications"
            />
        </div>
    </form-row>
</template>

<script>
import SendNotifications from './send-notifications.vue';

export default {
    components: {
        SendNotifications,
    },

    props: {
        contact: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
